import React from 'react'

interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  children?: React.ReactNode
}

export const Divider: React.FC<DividerProps> = ({ className, children, ...rest }) => {
  return (
    <div className={`flex w-full items-center border-gray-200 ${className}`} {...rest}>
      <div className="flex-1 border-t border-inherit"></div>
      {children && <div className="px-2 text-xs text-gray-300">{children}</div>}
      <div className="flex-1 border-t border-inherit"></div>
    </div>
  )
}

export const Spacer: React.FC<{ className?: string }> = ({ className }) => <div className={`mt-1 ${className || ''}`} />
